import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import PlusIcon from './shared/icons/Plus';
import { textStyles, colorPalette } from '../styles/styleGuide';
import { openModal } from '../redux/modal';
import { getResultData, getApiDataRequest, performApiRequest, invalidateApiDataRequest } from '../redux/apiData';
import get from 'lodash.get';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env;
  return {
    logoUrl: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'logoUrl', undefined),
    phase: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'phase', undefined),
    houseId: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'user.customer.houseId', undefined),
    wishLists: getResultData(state.apiData, 'getWishLists', {
      projectSlug: String(projectSlug)
    }),
    postWishListRequest: getApiDataRequest(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    handleClick: function handleClick(evt, phase, priceListBlockId, houseId) {
      evt.preventDefault();
      if (phase === 'cj1') {
        dispatch(openModal(colorPalette.lightOrange, {
          type: 'pricelist',
          componentProps: {
            projectSlug: String(projectSlug),
            priceListBlockId: priceListBlockId
          }
        }));
      } else {
        // immediately start a new design for house that customer is bound to
        dispatch(performApiRequest('postWishList', {
          projectSlug: String(projectSlug)
        }, {
          house: houseId
        }));
        dispatch(invalidateApiDataRequest('getWishLists', {
          projectSlug: String(projectSlug)
        }));
      }
    }
  };
};
var MakeWishListCard = /*#__PURE__*/function (_Component) {
  function MakeWishListCard() {
    _classCallCheck(this, MakeWishListCard);
    return _callSuper(this, MakeWishListCard, arguments);
  }
  _inherits(MakeWishListCard, _Component);
  return _createClass(MakeWishListCard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
        match = _this$props.match,
        postWishListRequest = _this$props.postWishListRequest,
        router = _this$props.router;
      if (postWishListRequest && postWishListRequest.networkStatus === 'success') {
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed/homestudio/").concat(String(postWishListRequest.result)));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        handleClick = _this$props2.handleClick,
        houseId = _this$props2.houseId,
        phase = _this$props2.phase,
        priceListBlockId = _this$props2.priceListBlockId,
        wishLists = _this$props2.wishLists,
        logoUrl = _this$props2.logoUrl;
      return __jsx(Card, {
        "data-e2e-card-makewishlistcard": true,
        onClick: function onClick(evt) {
          return phase ? handleClick(evt, phase, priceListBlockId, houseId) : undefined;
        },
        "data-id": "components_MakeWishListCard_Card"
      }, __jsx(Logo, {
        src: logoUrl,
        "data-id": "components_MakeWishListCard_Logo"
      }), __jsx(CreateCTA, {
        "data-id": "components_MakeWishListCard_CreateCTA"
      }, __jsx(Icon, {
        "data-id": "components_MakeWishListCard_Icon"
      }, __jsx(PlusIcon, {
        "data-id": "components_MakeWishListCard_PlusIcon"
      })), wishLists && wishLists.length ? 'Maak een nieuw woonontwerp' : 'Maak een woonontwerp'));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(MakeWishListCard));
var Card = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 20rem;\n  position: relative;\n  min-height: 500rem;\n  cursor: pointer;\n  border: 1rem dashed #979797;\n  background-color: transparent;\n  transition: background-color 0.2s ease-in-out;\n\n  &:hover {\n    background: #fff;\n    > img {\n      filter: grayscale(0%);\n    }\n    > div {\n      color: ", ";\n\n      > span {\n        background-color: ", ";\n      }\n    }\n  }\n"])), colorPalette.darkBlue, colorPalette.darkBlue);
var Logo = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-width: 220rem;\n  height: auto;\n  filter: grayscale(100%);\n  background-blend-mode: multiply;\n"])));
var CreateCTA = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n  text-align: center;\n  ", ";\n  font-weight: bold;\n  text-decoration: none;\n  color: ", ";\n  transition: color 0.2s ease-in-out;\n  justify-content: center;\n  margin-top: 40rem;\n"])), textStyles.bodyText, colorPalette.blue);
var Icon = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 26rem;\n  height: 26rem;\n  background-color: ", ";\n  transition: background-color 0.2s ease-in-out;\n  box-sizing: border-box;\n  padding: 7rem;\n  margin-right: 12rem;\n  border-radius: 50%;\n"])), colorPalette.lightBlue);